import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import MenuHorizontal from "../../layouts/MenuHorizontal";
import { Input, Button, Form, Icon } from "semantic-ui-react";
import { CabecalhoForm, SecaoForm, AvisoForm, RodapeForm } from "../../layouts/FormUI";
import { findById, findByIdAndUpdate } from "../../../actions/responsavel";
import * as FormValidator from "../../../utils/formValidator";
import Erro from '../../layouts/mensagens/Erro';
import MenuVertical from '../../layouts/MenuVertical';
import { Redirect, Link } from 'react-router-dom';
import InputMask from "react-text-mask";
import { formatDocumento } from '../../../utils/formatador';
import api from '../../../api';

class EditarResponsavel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      condominio: {},
      responsavel: props.responsavel,
      errors: {},
      sucesso: false,
      loading: true
    };
  }

  componentDidMount = async () => {
    try {
      await this.props.findById(this.props.match.params.id);
      const condominio = await api.condominio.findSimpleById(this.props.match.params.condominioId);
      this.setState({
        condominio,
        errors: this.props.errors,
        loading: false,
        responsavel: this.props.responsavel,
      });
    } catch (e) {
      this.setState({
        loading: false,
        errors: {
          ...this.props.errors,
          ...(e.data && e.data.errors) || {},
        },
      });
    }
  }

  onChange = e => {
    this.setState({
      responsavel: { ...this.state.responsavel, [e.target.name]: e.target.value },
      errors: {}, sucesso: false
    });
  }

  validate = responsavel => {
    const errors = {};

    if (FormValidator.isVazio(responsavel.nome)) {
      errors.nome = 'Nome é obrigatório';
    }

    if (FormValidator.isVazio(responsavel.email)) {
      errors.email = 'Email é obrigatório';
    }

    if (!FormValidator.isVazio(responsavel.email) && !FormValidator.isEmail(responsavel.email)) {
      errors.email = 'Email inválido';
    }

    if (!FormValidator.isVazio(responsavel.celular.replace(/\D/g, '')) && !FormValidator.isNumeroCelular(responsavel.celular)) {
      errors.celular = 'Número de celular inválido';
    }

    return errors;
  }

  onSubmitEditar = async (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.responsavel);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      await this.props.findByIdAndUpdate(this.state.responsavel._id, this.state.responsavel);
      this.setState({
        loading: false,
        sucesso: (Object.keys(this.props.errors).length === 0),
        errors: this.props.errors
      });
    }
  }

  render() {
    const { responsavel, errors, loading, sucesso, condominio } = this.state;
    const voltar = `/condominios/${condominio._id || this.props.match.params.condominioId}/responsaveis`;

    return (
      <div>
        {!!errors.global && <Redirect to="/" />}
        <MenuHorizontal />
        <div className="corpo-dashboard">
          <MenuVertical condominio={condominio} loading={loading} />
          <div className="va-imp-pagina">
            <CabecalhoForm
              voltar={voltar}
              voltarTexto="Proprietários"
              titulo={responsavel.nome ? `Editar proprietário · ${responsavel.nome}` : 'Editar proprietário'}
              descricao="Atualize o nome e os contatos. O documento identifica a pessoa e não pode ser alterado."
            />
            {!!errors.error && <Erro text={errors.error} tipo="block" />}
            {sucesso && (
              <div className="va-res-banner sucesso" role="status">
                <Icon name="check circle outline" size="big" />
                <div>
                  <b>Proprietário atualizado com sucesso</b>
                  <div className="va-res-acoes">
                    <Link to={voltar} className="ui button btn-ui-1 small"><Icon name="users" /> Voltar para os proprietários</Link>
                  </div>
                </div>
              </div>
            )}
            {!sucesso && (
              <Form onSubmit={this.onSubmitEditar} loading={loading} autoComplete="off" className="va-imp">
                <SecaoForm icone="user outline" titulo="Dados do proprietário">
                  <Form.Group widths="equal">
                    <Form.Field>
                      <label htmlFor="documento">Documento (CPF ou CNPJ)</label>
                      <Input id="documento" name="documento" type="text" value={formatDocumento(responsavel.documento)} placeholder="CPF ou CNPJ" loading={loading} disabled={true} />
                    </Form.Field>
                    <Form.Field error={!!errors.nome} required>
                      <label htmlFor="nome">Nome completo</label>
                      <Input id="nome" name="nome" type="text" placeholder="Nome do proprietário" onChange={this.onChange} value={responsavel.nome || ''} loading={loading} />
                      <Erro text={errors.nome} />
                    </Form.Field>
                  </Form.Group>
                </SecaoForm>

                <SecaoForm icone="address book outline" titulo="Contato" descricao="Usado para enviar o token de acesso ao aplicativo e as notificações.">
                  <Form.Group widths="equal">
                    <Form.Field error={!!errors.celular}>
                      <label htmlFor="celular">Celular</label>
                      <InputMask
                        type="text"
                        id="celular"
                        name="celular"
                        placeholder="(ddd) número"
                        mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                        guide={true}
                        onChange={this.onChange}
                        value={responsavel.celular || ''}
                      />
                      <Erro text={errors.celular} />
                    </Form.Field>
                    <Form.Field error={!!errors.email}>
                      <label htmlFor="email">E-mail</label>
                      <Input id="email" name="email" type="text" placeholder="E-mail" onChange={this.onChange} value={responsavel.email || ''} />
                      <Erro text={errors.email} />
                    </Form.Field>
                  </Form.Group>
                  <AvisoForm icone="info circle">As alterações valem para todas as unidades votantes vinculadas a este proprietário.</AvisoForm>
                </SecaoForm>

                <RodapeForm>
                  <Button type="submit" loading={loading} disabled={loading} className="btn-ui-1" size="large">
                    <Icon name="save" /> Salvar alterações
                  </Button>
                  <Link to={voltar} className="ui basic large button">Cancelar</Link>
                </RodapeForm>
              </Form>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    responsavel: state.responsavel.responsavel,
    errors: state.responsavel.errors,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    findById,
    findByIdAndUpdate,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(EditarResponsavel);
